import * as React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import styles from "./SearchResult.module.css"

const options = [
    "Newest",
    // "Most popular",
    "Name A-Z",
];

const ShortByDropdown = (props) => {

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const open = Boolean(anchorEl);
  const handleClickListItem = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = (event, index) => {
    setSelectedIndex(index);
    setAnchorEl(null);
    props.onSelect(options[index]);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className={`${styles.orderStatusContainer} ${styles.boxShadow}`}>
      <List
        component="nav"
        aria-label="Device settings"
        sx={{
        //   bgcolor: "#4C9F41",s
          // bgcolor: selectedIndex === 0 ? "#FF62003D" : "#4C9F413D",
          border: '1px solid #D2D3D8',
          borderRadius: '8px',
          "&.MuiList-root": {
            padding: '0 !important'
          },
          "& .MuiButtonBase-root.MuiListItem-root": {
            padding: "0 16px !important",
          },
        }}
      >
        <ListItem
          button
          id="lock-button"
          aria-haspopup="listbox"
          aria-controls="lock-menu"
          aria-label="when device is locked"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClickListItem}
        >
          <ListItemText
            primary="Sort by"
            secondary={options[selectedIndex]}
            sx={{
              "& .MuiTypography-root.MuiTypography-body1": {
                fontSize: "12px !important",
                color: "#0B132B !important",
                // color: selectedIndex === 0 ? "#FF6200" : "green",
              },
              "& .MuiTypography-root.MuiTypography-body2": {
                fontSize: "14px !important",
                fontWeight: "500",
                color: "#0B132B !important",
                // color: selectedIndex === 0 ? "#FF6200" : "green",
              },
            }}
          />
          <ArrowDropDownRoundedIcon sx={{ color: "#000000 !Important"}}/>
        </ListItem>
      </List>
      <Menu
        id="lock-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "lock-button",
          role: "listbox",
        }}
      >
        {options.map((option, index) => (
          <MenuItem
            key={option}
            //   disabled={index === 0}
            selected={index === selectedIndex}
            onClick={(event) => handleMenuItemClick(event, index)}
            sx={{
              color: "black",
              fontWeight: "400",
              "& p": {
                fontSize: "16px !important",
                backgroundColor:
                  index === 0 ? "#FF6200 !important" : "green !important",
              },
            }}
          >
            {option}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default ShortByDropdown;
